export default __webpack_public_path__ + "static/media/d-wall.b664cc8d.svg";